import { Spinner } from '@creditornot/cb-progress';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import CampaignHeader from './CampaignHeader';
import { CampaignStatus } from '../types';

export type CampaignLayoutProps = {
  heading?: string;
  children?: React.ReactNode;
  isLoading?: boolean;
  status?: CampaignStatus;
  venueCount?: number;
  tabs?: React.ReactNode;
  actions?: React.ReactNode;
};

const StyledWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  flex-grow: 1;
`;

const NotFoundWrapper = styled.div`
  text-align: center;
`;

const StyledSpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  min-height: 100%;
  padding: 60px;
`;

export const CampaignPageLayout = ({
  heading,
  children,
  isLoading,
  status,
  venueCount,
  tabs,
  actions,
}: CampaignLayoutProps) => {
  return (
    <>
      <CampaignHeader title={heading || ''} isCampaignSubpage status={status} venueCount={venueCount} tabs={tabs}>
        {actions}
      </CampaignHeader>
      <StyledWrapper>
        {isLoading ? (
          <StyledSpinnerWrapper>
            <Spinner size="large" />
          </StyledSpinnerWrapper>
        ) : (
          children || (
            <NotFoundWrapper>
              <h1>
                <FormattedMessage id="not-found.header" />
              </h1>
              <p>
                <FormattedMessage id="not-found.description" />
              </p>
            </NotFoundWrapper>
          )
        )}
      </StyledWrapper>
    </>
  );
};
